"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const resolvers_1 = require("../resolvers");
const execute_operator_1 = __importDefault(require("./execute-operator"));
const execute_function_1 = __importDefault(require("./execute-function"));
const constants_1 = require("../../constants");
const reporter_1 = __importDefault(require("../../reporter"));
const getFn = (ast, data) => {
    const { models, context, repeatIndex } = data;
    const modelIds = (0, resolvers_1.resolveModelIds)({
        modelRef: {
            modelIds: context,
            ...ast,
        },
        models,
        repeatIndex,
    });
    if (!modelIds || !modelIds.length) {
        reporter_1.default.warn(`There was a problem with this ast`);
        return null;
    }
    const { attr } = ast;
    const { id, index } = modelIds[0];
    const dataItem = models[index][id];
    return dataItem ? dataItem[attr || constants_1.MODEL_CONTENTS] : '';
};
const setFn = (ast, data) => {
    if (!data)
        return undefined;
    return getFn(ast, data);
};
const noMatchingType = type => ast => {
    // if object shape is { value: 'foo' } return the value
    const keys = Reflect.ownKeys(ast);
    if (keys.length === 1 && keys[0] === 'value') {
        return ast.value;
    }
    // otherwise this is an unhandled type
    return reporter_1.default.log('Unhandled type:', type);
};
const mappings = type => ({
    operator: execute_operator_1.default,
    get: getFn,
    set: setFn,
    function: execute_function_1.default,
}[type] || noMatchingType(type));
const executeLogic = ({ ast: { type, ...ast }, data }) => mappings(type)(ast, data);
exports.default = executeLogic;
//# sourceMappingURL=index.js.map